export default function CTASection() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-slate-900 via-teal-900 to-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      {/* Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-md rounded-full mb-8 border border-white/20">
          <i className="ri-customer-service-line text-teal-400 text-xl mr-3"></i>
          <span className="text-sm font-bold text-white">CONTACT US</span>
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-white mb-6">
          まずは<span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">無料相談</span>から
        </h2>

        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          会社売却に関するご相談は無料です。<br />
          お気軽にお問い合わせください。
        </p>

        {/* Contact Methods */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-12">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-black text-white mb-2">メール</h3>
            <p className="text-sm text-teal-400 mb-2">info@nextage.jp</p>
            <p className="text-sm text-gray-400">24時間受付</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-chat-3-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-black text-white mb-2">LINE相談</h3>
            <p className="text-sm text-teal-400 mb-2">@nextage-ma</p>
            <p className="text-sm text-gray-400">友だち追加で簡単相談</p>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a
            href="#"
            className="group px-10 py-5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/30 transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer"
          >
            売却申込・査定フォーム
            <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="mailto:info@nextage.jp"
            className="group px-10 py-5 bg-white text-gray-900 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
            <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
